export default __webpack_public_path__ + "static/media/circle_3.3580777d.png";